module.exports = __webpack_public_path__ + "img/link.84fe9d44.svg";